<div class="cm-list-title">
    <ng-content select="[cm-title]"></ng-content>
</div>
<div class="cm-list">
    <ng-content select="[cm-list]"></ng-content>
</div>
